module.exports = __webpack_public_path__ + "static/media/Testing_Area_Light.3f70a445.svg";